var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChipList',{attrs:{"item":{items: _vm.advanced_filter_items},"disable":_vm.disable},on:{"update":_vm.chip_clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }